import styled from 'styled-components';
import { theme } from "../../configuration";

const PageHeading = styled.h3`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: ${theme.colours.heading};
  font-family: ${theme.fonts.heading};
  font-size: ${props => props.small ? "1em" : "1.3em"};
  margin: ${props => props.small ? "10px 0px 0px 0px" : "1em 0 0 0"};
  margin-top:6px;
`;

export default PageHeading;

